import { z } from 'zod';

export const NorthlightRenewalsSchema = z.object({
	id: z.number().nullable(),
	policyNumber: z.string().min(1, 'please enter policy number'),
	policyEffectiveDate: z.string().min(1, 'please select choose effective date'),
	renewalTerms: z.string().nullable(),
	agentName: z.string().nullable(),
	agentLastName: z.string().nullable(),
	agentEmail: z.string().nullable(),
	billToList: z
		.array(
			z.object({
				text: z.string(),
				value: z.string(),
			}),
		)
		.min(1, 'please select atleast one option'),
	file: z.instanceof(File, { message: 'file is required' }),
	billto: z.string().nullable(),
});

export type FormResponse = {
	legalname: string;
	recipient: string;
	attachmentname: string;
	attachmentencoded: string;
	body: string;
	insert_ts: string;
	deliverytimeest: string;
	bcc: boolean;
	emailtype: number;
	sender: string;
	subject: string;
};

export type DownloadFileParams = {
	filename?: string;
};
export type ApiResponse = {
	error?: string;
	message?: string;
	[key: string]: any;
};

export type NorthlightRenewals = z.infer<typeof NorthlightRenewalsSchema>;

export const add = async (
	northlightRenewals: NorthlightRenewals,
): Promise<any> => {
	const formData = new FormData();

	Object.entries(northlightRenewals).forEach(([key, value]) => {
		if (
			key !== 'file' &&
			key !== 'billToList' &&
			value !== null &&
			value !== undefined
		) {
			formData.append(key, value.toString());
		}
	});

	const selectedOption = northlightRenewals.billToList?.[0];
	if (selectedOption) {
		formData.append('billToList[0].Text', selectedOption.text);
		formData.append('billToList[0].Value', selectedOption.value);
	}

	if (northlightRenewals.file) {
		formData.append('file', northlightRenewals.file);
	}

	try {
		const res = await fetch('/NorthlightRenewals/BuildInvoice', {
			method: 'POST',
			body: formData,
		});

		const data = await res.json();

		if (!res.ok || data?.statusCode >= 400) {
			const errorText =
				data.message || data.error || res.statusText || 'Internal server error';
			throw new Error(errorText);
		}
		return data;
	} catch (error: any) {
		if (error instanceof Response) {
			const errorData = await error.json();
			const message = errorData?.message || errorData?.error || 'Server error';
			throw new Error(message);
		}
	}
};

export const downloadFile = async ({
	filename,
}: DownloadFileParams): Promise<void> => {
	if (!filename) {
		console.warn('no file');
		return;
	}
	const justfilename = filename.split(/[\\/]/).pop() ?? 'invoice.pdf';
	const encodedFileName = encodeURIComponent(justfilename);
	const res = await fetch(`/NorthlightRenewals/Download?FileName=${encodedFileName}`);
	if (!res.ok) {
		throw new Error('Failed to download file');
	}
	const blob = await res.blob();
	const downloadUrl = window.URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = downloadUrl;
	a.download = filename.split('\\').pop() ?? 'invoice.pdf';
	document.body.appendChild(a);
	a.click();
	a.remove();
};
export const sendInvoice = async (data: FormResponse): Promise<void> => {
	const res = await fetch('/NorthlightRenewals/SendInvoice', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});
	if (!res.ok) {
		console.log('Failed to send invoice');
	}
	return res.json();
};